import { WidgetType } from '@enums/WidgetType'
import dynamic from 'next/dynamic'

export const widgetImports = {
  [WidgetType.PUC_WIDGET]: dynamic(() => import('./Puc/pucWidgetModal'), {
    ssr: true,
  }),
  [WidgetType.RTO_VEHICLE_INFO_WIDGET]: dynamic(() => import('./RtoVehicleInfo/rtoVehicleInfoWidgetModal'), {
    ssr: true,
  }),
  [WidgetType.RTO_DETAIL_WIDGET]: dynamic(() => import('./RtoDetail/rtoDetailWidgetModal'), {
    ssr: true,
  }),
  [WidgetType.CHALLAN_WIDGET]: dynamic(() => import('./ChallanWidget/challanWidgetModal'), {
    ssr: true,
  }),
}
